import React, { useState } from "react";
import { SliderControlSettingsModel } from "../model/slider-control.settings.model";
import { OptionRangeModelArray } from "../model/option-range.model";
import { QqControlPropsType } from "./qq-control-props.type";
import { sliderAction } from "../message-interop/control-actions/slider.action";
import { Slider } from "@mui/material";
import { QqQuizControlContainerComponent } from "./qq-quiz-control-container.component";
import {
  ControlTitleTypography,
  SliderDimensionTypography,
  SubTitleTypography,
} from "./qq-typohraphy.controls";
import Grid from "@mui/material/Grid";
import { EquationProcessorService } from "../services/equation-processor.service";
import _ from "lodash";
import InputBase from "@mui/material/InputBase";

export const QqSliderControl: React.FunctionComponent<
  QqControlPropsType<SliderControlSettingsModel, OptionRangeModelArray>
> = ({ qq, dispatch, state, settings }) => {
  const curValue = state.ctrlPos[qq.key];
  const [curDimension, setCurrentDimension] = useState<string>("");

  // const [disabled, setDisabled] = useState<boolean>(
  //   settings.range[0] > curValue || settings.range[1] < curValue
  // );

  // useEffect(() => {
  //   if (settings.range[0] > curValue || settings.range[1] < curValue) {
  //     setDisabled(true);
  //   }
  // }, [curValue, settings.range]);

  if (qq.visible !== undefined && !qq.visible) return <span />;
  const { qqBundle, currentOptions, ctrlBundle } = state;
  const equationProcessor = new EquationProcessorService(
    qqBundle,
    ctrlBundle,
    currentOptions
  );

  const formatOut: any = equationProcessor.processEquation(qq, settings.out);
  const formatIn: any = equationProcessor.processEquation(qq, settings.in);

  let outValue = curValue;
  let outDimension = curDimension;

  if (_.isFunction(formatOut)) {
    const out: any = formatOut({ v: curValue, d: curDimension });
    outValue = out.v;
    outDimension = out.d;
    if (curDimension !== outDimension) setCurrentDimension(outDimension);
  }

  return (
    <QqQuizControlContainerComponent>
      <ControlTitleTypography>{qq.text}</ControlTitleTypography>
      <Grid container spacing={2} alignItems="center">
        <Grid item>
          <SubTitleTypography>{settings.labels[0] ?? ""}</SubTitleTypography>
        </Grid>
        <Grid
          item
          xs
          // onMouseDown={() => disabled && setDisabled(false)}
          sx={{
            cursor: "pointer",
          }}
        >
          <Slider
            // disabled={disabled}
            size="small"
            value={curValue ?? 0}
            min={settings.range[0] ?? 0}
            max={settings.range[1] ?? 100}
            onChange={(_, value) => {
              dispatch(
                sliderAction(
                  qq,
                  Array.isArray(value)
                    ? (value[0] as number)
                    : (value as number)
                )
              );
            }}
          />
        </Grid>
        <Grid item>
          <SubTitleTypography>{settings.labels[1] ?? ""}</SubTitleTypography>
        </Grid>
        <Grid
          sx={{
            minWidth: "70px",
            textAlign: "right",
            display: "flex",
            alignItems: "center",
            border: "1px solid #5f6368",
            padding: "1px",
            paddingRight: "4px",
            marginLeft: "14px",
            borderRadius: "4px",
          }}
        >
          <InputBase
            value={outValue}
            inputProps={{
              sx: {
                textAlign: "right",
                paddingLeft: "4px",
                paddingRight: "4px",
              },
            }}
            sx={{
              flexGrow: 1,
              textAlign: "right",
              width: "30px",
              fontFamily: "Roboto-Regular!important",
              fontSize: `13px !important`,
            }}
            onChange={(e) => {
              const res = formatIn({ v: e.target.value, d: curDimension });
              if (curDimension !== res.d) {
                setCurrentDimension(res.d);
              }
              dispatch(sliderAction(qq, res.v));
            }}
          />
          <SliderDimensionTypography>{outDimension}</SliderDimensionTypography>
        </Grid>
      </Grid>
    </QqQuizControlContainerComponent>
  );
};
